var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 .667H4A3.332 3.332 0 00.668 4v30a3.332 3.332 0 003.334 3.333h30A3.332 3.332 0 0037.334 34V4A3.333 3.333 0 0034 .667zm-2.184 15.79c-.217.02-.435.033-.655.033a7.117 7.117 0 01-5.957-3.218v10.961A8.102 8.102 0 119 24.232a8.102 8.102 0 018.101-8.102c.17 0 .335.015.5.025v3.993c-.166-.02-.328-.05-.5-.05a4.136 4.136 0 000 8.27c2.285 0 4.302-1.8 4.302-4.083l.04-18.617h3.815a7.114 7.114 0 006.557 6.352v4.437z",
    fill: "#fff"
  })));
}
export default SvgTiktokWhite;